/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Find_Replace_Search_Results_ToastInputs */



/**
* | output |
* | --- |
* | "Search returned {count} results" |
*
* @param {Find_Replace_Search_Results_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_search_results_toast = /** @type {((inputs: Find_Replace_Search_Results_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Search_Results_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`La recherche a retourne ${i?.count} resultats`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Suche ergab ${i?.count} Ergebnisse`)
	if (locale === "it") return /** @type {LocalizedString} */ (`La ricerca ha restituito ${i?.count} risultati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Поиск выдал ${i?.count} результатов`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La búsqueda arrojó ${i?.count} resultados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`搜索结果为${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`検索により ${i?.count} 件の結果が返されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`खोज में ${i?.count} परिणाम प्राप्त हुए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A pesquisa retornou ${i?.count} resultados`)
	return /** @type {LocalizedString} */ (`Search returned ${i?.count} results`)
});